import { t } from '@/features/i18n/utils';
import { useWorkspace } from '@/features/workspaces/helpers';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import {
  Header,
  HeaderChatButton,
  HeaderBackButton,
  HeaderNextNavButton,
  HeaderNav,
  HeaderPrevNavButton,
} from '@/ui/components/header';
import { useAmbiguityHeaderNav } from '@/features/ambiguities/helpers';
import { ambiguityStatementsQuery } from '@/features/ambiguities/queries';
import { AmbiguityDetailPage } from '@/features/ambiguities/components/ambiguity-detail-page';
import { useSuspenseQuery } from '@tanstack/react-query';
import { NotFound } from '@/ui/components/not-found';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/$ambiguityId',
)({
  staticData: { chatSurface: 'ambiguity' },
  component: RouteComponent,
});

function RouteComponent() {
  const { workspaceId, projectId, ambiguityId } = Route.useParams();
  const workspace = useWorkspace();

  const { data: allAmbiguitiesData } = useSuspenseQuery(
    ambiguityStatementsQuery(workspace.type, workspaceId),
  );
  const allStatements = allAmbiguitiesData?.statements;

  const data = allStatements?.find((item) => item.id === ambiguityId);

  const { handlePrevious, handleNext, isPreviousDisabled, isNextDisabled } = useAmbiguityHeaderNav(
    allStatements,
    ambiguityId,
    (ambiguityId) => ({
      to: '/project/$projectId/workspaces/$workspaceId/ambiguities/$ambiguityId',
      params: { projectId, workspaceId, ambiguityId },
    }),
  );

  if (!data) return <NotFound />;

  return (
    <>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId/ambiguities"
          params={{ projectId, workspaceId }}
        />
        <WorkspaceBreadcrumbs>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId/ambiguities"
            params={{ projectId, workspaceId }}
          >
            {t({ en: 'Ambiguities', nb: 'Uklare formuleringer' })}
          </BreadcrumbLink>
          <BreadcrumbPage className="tabular-nums">#{data.displayNumber}</BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderNav>
          <HeaderPrevNavButton onClick={handlePrevious} disabled={isPreviousDisabled} />
          <HeaderNextNavButton onClick={handleNext} disabled={isNextDisabled} />
        </HeaderNav>
        <HeaderChatButton />
      </Header>
      <AmbiguityDetailPage data={data} />
    </>
  );
}
